"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelDTO = exports.PressDTO = exports.FTUEDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
let FTUEDTO = class FTUEDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.FTUEDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "action", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "category", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Which FTUE did the user experience?'),
    __metadata("design:type", String)
], FTUEDTO.prototype, "action", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Category of the FTUE'),
    __metadata("design:type", String)
], FTUEDTO.prototype, "category", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Version of the FTUE item/category'),
    __metadata("design:type", String)
], FTUEDTO.prototype, "version", void 0);
FTUEDTO = __decorate([
    (0, decorators_1.Describe)('First Time User Experience presented to the user')
], FTUEDTO);
exports.FTUEDTO = FTUEDTO;
let PressDTO = class PressDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PressDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Identifier for this interaction'),
    __metadata("design:type", String)
], PressDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Context in which the action took place'),
    __metadata("design:type", String)
], PressDTO.prototype, "context", void 0);
PressDTO = __decorate([
    (0, decorators_1.Describe)('User interaction via touch, click, press'),
    (0, decorators_1.Warning)('Do not use in place of more granular DTOs')
], PressDTO);
exports.PressDTO = PressDTO;
let CancelDTO = class CancelDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.CancelDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "context", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Identifier for this interaction'),
    __metadata("design:type", String)
], CancelDTO.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Context in which the action took place'),
    __metadata("design:type", String)
], CancelDTO.prototype, "context", void 0);
CancelDTO = __decorate([
    (0, decorators_1.Describe)('User interaction resulting in cancellation')
], CancelDTO);
exports.CancelDTO = CancelDTO;
